import { findEvent } from '../../../packages/src/api/index.js';

init();

async function init() {
  if (!getEvent()) {
    alert("Didn't set event name in the index.html");
    window.location.reload();
  }

  if (!getHomeLink()) {
    alert("Didn't set home in the index.html");
    window.location.reload();
  }

  const response = await findEvent({ eventName: getEvent() });
  const { opts } = response.result;
  setText(getPrivacyText(opts));
  showArticle();
  // activateButtons({ isShowAccept: !isAcceptedPrivacy() });
  activateButtons({ isShowAccept: false });
}

function setText(text) {
  const elem = document.querySelector('.html-content');
  elem.innerHTML = text;
}

function getPrivacyText(opts) {
  return opts.agreementText;
}

function showArticle() {
  const elem = document.querySelector('.html-content');
  elem.classList.add('html-content_show');
}

function makeBtn({ cssPath }) {
  return { type: '$Button', cssPath };
}

const agreeBtn = makeBtn({ cssPath: '#accept' });
const backBtn = makeBtn({ cssPath: '#back' });

function acceptPrivacy() {
  localStorage.setItem('isAcceptedPrivacy', true);
}

function onClick(cb, elem) {
  const e = document.querySelector(elem.cssPath);
  e.addEventListener('click', cb);
}

function getHomeLink() {
  return localStorage.getItem('home');
}

function goBack() {
  window.history.go(-1);
}

function getEvent() {
  return localStorage.getItem('eventName');
}

function hideButton(elem) {
  const e = document.querySelector(elem.cssPath);
  if (e) {
    e.style.display = 'none';
  }
}
function showButton(elem) {
  const e = document.querySelector(elem.cssPath);
  if (e) {
    e.style.display = 'block';
  }
}

function activateButtons({ isShowAccept }) {
  if (isShowAccept) {
    hideButton(backBtn);
    showButton(agreeBtn);

    onClick(() => {
      acceptPrivacy();
      goBack();
    }, agreeBtn);
  } else {
    hideButton(agreeBtn);
    showButton(backBtn);

    onClick(() => {
      goBack();
    }, backBtn);
  }
}
